var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50003 1.55615C8.02179 1.55623 10.0605 3.64654 10.0605 6.23135C10.0604 7.45127 9.49761 8.9489 8.69282 10.441C7.89824 11.9141 6.91347 13.3008 6.16341 14.2776C5.8153 14.7307 5.18395 14.7308 4.83584 14.2776C4.08578 13.3008 3.10101 11.9141 2.30643 10.441C1.50171 8.9489 0.938862 7.45127 0.938782 6.23135C0.938782 3.64646 2.9781 1.55615 5.50003 1.55615Z",
    stroke: "#0E1318",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50579 7.33134C6.09848 7.33134 6.57895 6.83886 6.57895 6.23134C6.57895 5.62383 6.09848 5.13135 5.50579 5.13135C4.91309 5.13135 4.43262 5.62383 4.43262 6.23134C4.43262 6.83886 4.91309 7.33134 5.50579 7.33134Z",
    stroke: "#0E1318"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.9756ceeb1d8b48e7e95fc65237377c30.svg";
export { ForwardRef as ReactComponent };